import { Component } from '@angular/core';
import { DataService } from 'src/app/services/data.service';
import { MessageService } from 'src/app/services/message.service';

@Component({
  selector: 'app-items-list',
  templateUrl: './items-list.component.html',
  styleUrls: ['./items-list.component.css']
})
export class ItemsListComponent {
  url: string       = 'invoice/items';

  data: Array<any>  = [];
  isLoading: boolean = false;

  constructor(
    private dataService: DataService,
    private messageService: MessageService
  ) { }

  ngOnInit(): void {
    this.getData();
  }

  getData(): void {
    this.isLoading = true;
    this.dataService.getData(`${this.url}/list`).subscribe(response => {
      this.data = response.data;
      this.isLoading = false;
    });
  }

  deleteData(id: string): void {
    if (!confirm('You want to delete the record?')) {
      return;
    }

    this.dataService.deleteData(`${this.url}/delete/${id}`).subscribe(response => {

      if (response.rst) {
        //this.messageService.add(response.msg, 'info');
      } else {
        this.messageService.add(response.msg, 'danger');
      }

      this.getData();
    });
  }


}
